/**
 * Whether this till should be showing the setup wizard instead of the shop.
 *
 * Three states, not two, and the third is the one that matters: `true` is a
 * paired till, `false` is a fresh install that must pair before it can do
 * anything, and UNDEFINED is "the agent has not told us yet".
 *
 * Reading undefined as unpaired would flash a setup screen at a working shop
 * every time the status call is slow — on the till that runs the counter,
 * mid-service. Reading it as paired is the failure we already shipped: the
 * sale screen appeared on a device with no identity, claimed to be online and
 * fully synced, and failed with an internal error.
 *
 * So: only an explicit `false` means show the wizard.
 */
export function needsSetup(activated: boolean | undefined): boolean {
  return activated === false;
}

/**
 * Whether to keep asking the agent for its status.
 *
 * Pairing restarts the agent, and it is unreachable while it comes up. The
 * setup screen must wait for the agent to answer rather than for a delay
 * somebody guessed — a guess that was too short left a paired till sitting on
 * a "preparing…" screen with nothing left to retry.
 */
export function shouldKeepAsking(activated: boolean | undefined): boolean {
  return activated === false;
}
